import { createContext, useState } from "react";

export const context = createContext();

const { Provider } = context;

const RequirementsContext = ({ children }) => {
    const [dataGeneral, setDataGeneral] = useState([]);
    const [dataProperty, setDataProperty] = useState([]);
    const [dataTerrain, setDataTerrain] = useState([]);
    const [dataUser, setDataUser] = useState([]);
    const [location, setLocation] = useState("");
    const [step, setStep] = useState(0);

    const addDataGeneral = (data) => {
        setDataGeneral(data);
    };

    const addDataProperty = (data) => {
        setDataProperty(data);
    };

    const addDataTerrain = (data) => {
        setDataTerrain(data);
    };

    const addDataUser = (data) => {
        setDataUser(data);
    };

    const updateStep = (step) => {
        setStep(step);
    };

    return (
        <Provider
            value={{
                dataGeneral,
                dataProperty,
                dataTerrain,
                dataUser,
                location,
                step,
                addDataGeneral,
                addDataProperty,
                addDataTerrain,
                addDataUser,
                updateStep,
                setLocation,
            }}
        >
            {children}
        </Provider>
    );
};

export default RequirementsContext;
